var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DatatableV2',{attrs:{"displayTitle":false,"flat":true,"url":_vm.apiUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }